import axios from "axios";
import React, { Component } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "reactstrap";
import CustomerInfoTable from "./common/CustomerInfoTable";
import ReactToPrint from "react-to-print";
import "./reportminius.css";
import { configuration } from "../appConfig";
import CanadaPriceTable from "./common/CanadaPriceTable";
import CanadaCarSVG from "../carbodyparts/CanadaCarSVG";
import MPIPriceTable from "./common/MPIPriceTable";
import ScrollToTop from "./common/ScrollToTop";
import PreDamageSVG from "../carbodyparts/PreDamageSVG";
import AllReportScanImages from "./common/AllReportScanImages";
import ReportAuthorizationHandler from "./common/ReportAuthorizationHandler";
import ReportHeader_Swiss from "./common/ReportHeader_Swiss";
import ReportFooter_Swiss from "./common/ReportFooter_Swiss";
import Spinner from "../../src/spinner/index";
import SwissMiniReportAuthorization from "./common/SwissMiniReportAuthorization";
import SwissFullReportAuthorization from "./common/SwissFullReportAuthorization";
import CanadaPriceTable_Coop from "./common/CanadaPriceTable_Coop";
import PreDamage93SVG from "../carbodyparts/PreDamage93SVG";
import SgiEstevanPriceTable from "./common/SgiEstevanPriceTable";
import CanadaCaMiniReportAuthorization from "./common/CanadaCaMiniReportAuthorization";

export class ReportMiniEUCanada extends Component {
  constructor(props) {
    super(props);
    this.state = {
      words: {},
      lang: "",
      data: {},
      orderId: "",
      insuranceName: "",
      isJSONLoading: false,
      authorizeLoading: false,
      Authorized: false,
      totalDentsCount: 0,
      isOpenDentsModal: false,
      isOpenAuthorizeModal: false,
      optionArr: [],
      ccEmailOptionArr: [],
      ccAccountOptionArr: [],
      authorizerName: "",
      subject: "",
      ccEmailArr: [],
      ccAccountsArr: [],
      error: [],
      sendEmail: false,
      jsonData: {},
      emailArr: [],
      deAuthLoading: false,
      isSHowPreDamageImages: false,
      extraImageNameArr_1: [],
      extraNewImages: [],
      imageLoading: true,
      clientName : "",
      isAnyOnecheck : false

    };
    this.setImageLoading = this.setImageLoading.bind(this);
  }

  componentDidMount() {
    this.getLang();
    this.getOrderId();
    this.getPreDamageImages();
  }

  getPreDamageImages = () => {
    let partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url = `${configuration.getExtraImages}?partnerId=${partnerId}&vin=${vin}&partName=yes`;
    axios
      .get(url)
      .then((res) => {
        let extraImageNameArr_1 = [];
        if (res && res.data.extraNewImages) {
          for (const key in res.data.extraNewImages) {
            if (Object.hasOwnProperty.call(res.data.extraNewImages, key)) {
              const element = res.data.extraNewImages[key];
              const partName =
                element.name &&
                element.name.split("/")[element.name.split("/").length - 1];
              extraImageNameArr_1.push(partName);
            }
          }
          this.setState({
            extraImageNameArr_1,
            extraNewImages: res.data && res.data.extraNewImages,
          });
        }
      })
      .catch((err) => {
      });
  };

  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang, words: res.data });
    });
  };

  setImageLoading(loading) {
    this.setState({ imageLoading: loading });
  }

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  getOrderId = () => {
    this.setState({
      isJSONLoading: true,
    });
    axios
      .get(configuration.getData, {
        params: {
          vin: localStorage.getItem("selectedFile"),
          partnerId: localStorage.getItem("partnerId"),
        },
      })
      .then(async (res) => {
        const totalDentsCount =
          res.data.TotalDentCount > 0
            ? parseInt(res.data.TotalDentCount)
            : this.getTotalDentsCount(res.data.Dents);
        if (res && res.data) {
          this.setState({
            orderNo: res.data.OrderNo,
            insuranceName: res.data.InsurenceName ? res.data.InsurenceName : "",
            Authorized: res.data.Authorized || false,
            totalDentsCount,
            jsonData: res.data,
            isSHowPreDamageImages: res.data.PreDamage || false,
            clientName : res.data && res.data.Client

          }, () => this.checkStatus()); 
        }
        this.setState({
          isJSONLoading: false,
        });
      })
      .catch((err) => {
        this.setState({
          isJSONLoading: false,
        });
      });
  };

  getTotalDentsCount = (dentsArr) => {
    let totalDents = 0;

    const extraParts = [
      "Trunk",
      "LeftFrontTyre",
      "LeftBackTyre",
      "RightFrontTyre",
      "RightBackTyre",
      "FrontBumper",
      "BackBumper",
      "Underbody",
      "Inside",
    ];

    if (dentsArr.length) {
      totalDents = dentsArr.reduce((acc, num) => {
        if (!extraParts.includes(num.Part)) {
          return (
            parseFloat(acc) +
            parseFloat(num.A || 0) +
            parseFloat(num.B || 0) +
            parseFloat(num.C || 0) +
            parseFloat(num.D || 0)
          );
        } else {
          return parseFloat(acc);
        }
      }, 0);
    }

    return parseInt(totalDents);
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]:
        e.target.name === "name" ? e.target.value.trimStart() : e.target.value,
    });
  };

  handleSelectChange = (value, name) => {
    this.setState({
      [name]: value,
    });
  };

  changeAuthorizeFlag = (authorize, driveType) => {
    this.setState({
      jsonData: {
        ...this.state.jsonData,
        Authorized: authorize,
        DriveThrough:
          driveType === "drive_through"
            ? "0"
            : driveType === "drive_in"
              ? "1"
              : "",
      },
    });
  };
  checkStatus = () => {
    const { jsonData } = this.state;
    const isAnyOnecheck = jsonData && jsonData.Dents && jsonData.Dents.some(item => item.Ersetzen && item.Ersetzen.length > 0);
    this.setState({ isAnyOnecheck });
  }
  render() {
    const {
      isOpenAuthorizeModal,
      insuranceName,
      isJSONLoading,
      isOpenDentsModal,
      ccAccountOptionArr,
      ccEmailOptionArr,
      optionArr,
      authorizerName,
      subject,
      ccEmailArr,
      ccAccountsArr,
      error,
      sendEmail,
      extraImageNameArr_1,
      jsonData,
      lang,
      imageLoading,
      clientName
    } = this.state;
    const isMPIClient = ["mpi", "manitoba public insurence"].includes(
      insuranceName.toLowerCase(),
    );
    const isCoopClient = clientName && clientName.toLocaleLowerCase() == "coop" ? true : false;
    const isSgiEstevanClient = ["sgi","SGI", "SGI-Estevan","sgi-estevan","SGI-ESTEVAN"].includes((clientName && clientName.toLocaleLowerCase() || insuranceName && insuranceName.toLocaleLowerCase()))
    return (
      <div className="animated fadeIn">
        <div xs="12" sm="12" className="p-2">
          <Card className="print_button_card mt-2">
            <CardHeader>
              <div className="container-fluid">
                <div className="row align-items-center p-0">
                  <div className="col-lg-3 col-md-6 col-sm-6 col-12 mt-sm-10">
                    <small>
                      {" "}
                      <span>{this.lang("VIN")}:</span>{" "}
                      {localStorage.getItem("selectedFile")}
                    </small>
                  </div>
                  <div className="col-lg-9 col-md-8 col-sm-12 col-12 mt-sm-10 p-0">
                    <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                      {/* <ReportAuthorizationHandler
                        jsonData={jsonData}
                        lang={this.lang}
                        reportType={"mini_ca"}
                        isRemoveDriveThroughButton={true}
                        isAuthorized={jsonData.Authorized}
                        changeAuthorizeFlag={(authorize, driveType) =>
                          this.changeAuthorizeFlag(authorize, driveType)
                        }
                        selectedLanguage={lang}
                      /> */}
                      {/* <SwissMiniReportAuthorization /> */}
                      {/* <SwissFullReportAuthorization /> */}
                      <CanadaCaMiniReportAuthorization />
                      <ReactToPrint
                        trigger={() => {
                          document.title = document.title =
                            localStorage.getItem("selectedFile");
                          return (
                            <button className="btn btn-danger btn-lg pull-right">
                              <i className="fa fa-print" /> {this.lang("Print PDF")}
                            </button>
                          );
                        }}
                        content={() => this.componentRef}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </CardHeader>
          </Card>
        <div
          className="container reportmini us-letter-size-wrapper all-reports-top-wrapper"
          // id="divIdToPrint"
          ref={(el) => (this.componentRef = el)}
          style={{ padding: 0 }}
        >
          <div className="row row-zero page-break-row report-full-wrapper us-top-table-wrapper"
            data-content-name={this.lang("Page")}
          >
            <div className="col-sm-12 full-height-col col-zero">
              <Card>
                <CardBody className="col-zero">
                  <div className="newFormatReport_wrapper">
                    <ReportHeader_Swiss />
                    <CustomerInfoTable />
                    {/* <br /> &nbsp; */}
                    {isJSONLoading ? (
                      <div className="container mt-50 damage-summary-section p-0">
                        <div className="row p-0">
                          <div className="col-12 text-center">
                            <h4 className="text-center">Loading...</h4>
                          </div>
                        </div>
                      </div>
                    ) : isMPIClient ? (
                      <MPIPriceTable viewType="reportMiniEU" />
                    ) : isCoopClient ? (
                      <CanadaPriceTable_Coop viewType="reportMiniEU"/>
                    ) : isSgiEstevanClient ? (
                      <SgiEstevanPriceTable viewType="reportMiniEU"/>
                    ) : (
                      <CanadaPriceTable viewType="reportMiniEU" />
                    )}
                  </div>
                </CardBody>
                <ReportFooter_Swiss />
              </Card>
            </div>
          </div>
          {
            this.state.isAnyOnecheck &&
            <div className="row row-zero page-break-row report-full-wrapper us-top-table-wrapper"
            data-content-name={this.lang("Page")}
          >
            <div className="col-sm-12 full-height-col col-zero">
              <Card>
                <CardBody className="col-zero">
                  <div className="newFormatReport_wrapper">
                    <ReportHeader_Swiss />
                    {/* <br /> &nbsp; */}
                    {isJSONLoading ? (
                      <div className="container mt-50 damage-summary-section p-0">
                        <div className="row p-0">
                          <div className="col-12 text-center">
                            <h4 className="text-center">Loading...</h4>
                          </div>
                        </div>
                      </div>
                      ) : isMPIClient ? (
                        <MPIPriceTable is_extra_columns_visible_mini_fullreport={true}/>
                      ) : isCoopClient ? (
                        <CanadaPriceTable_Coop  viewType="reportMiniEU" is_extra_columns_visible_mini_fullreport={true} />
                      ) : (
                        <CanadaPriceTable viewType="reportMiniEU" is_extra_columns_visible_mini_fullreport={true} />
                      )}
                  </div>
                </CardBody>
                <ReportFooter_Swiss />
              </Card>
            </div>
          </div>
          }
        
          {/* 2D view */}
          {!imageLoading ? (
            <>
              <div className="row row-zero page-break-row report-full-wrapper"
                data-content-name={this.lang("Page")}
              >
                <div className="col-sm-12 full-height-col col-zero">
                  <Card>
                    <CardBody className="col-zero">
                      <div className="newFormatReport_wrapper">
                        <ReportHeader_Swiss />
                        <div className="container car-svg-main">
                          <div className="row title-row-main">
                            <div
                              className="col-sm-12 col-zero"
                            >
                              <h3 className="report-title">
                                2D {this.lang("View")}{" "}
                              </h3>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12">
                              <CanadaCarSVG {...this.props}/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                    <ReportFooter_Swiss />
                  </Card>
                </div>
              </div>

              {/* Pre Damage SVG */}
              <div className="row row-zero page-break-row report-full-wrapper"
                data-content-name={this.lang("Page")}
              >
                <div className="col-sm-12 full-height-col col-zero">
                  <Card>
                    <CardBody className="col-zero">
                      <div className="newFormatReport_wrapper">
                        <ReportHeader_Swiss />
                        <div className="container car-svg-main">
                          <div className="row title-row-main">
                            <div
                              // style={{ marginTop: "0rem" }}
                              className="col-sm-12 col-zero"
                            >
                              <h3 className="report-title">
                                Pre {this.lang("Damage")}{" "}
                              </h3>
                            </div>
                          </div>
                          <div className="row justify-content-center">
                            <div className="col-sm-11">
                              <div className="pre_damage_svg_print">
                                <PreDamage93SVG
                                  isDisableClick={true}
                                  extraImageNameArr_1={extraImageNameArr_1}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                    <ReportFooter_Swiss />
                  </Card>
                </div>
              </div>
            </>
          ) : (
            <>
              <Spinner />
            </>
          )}
          <AllReportScanImages imageLoading={this.state.imageLoading} setImageLoading={this.setImageLoading} />
        </div>
        {/* <div>
        {!imageLoading && (
            <>
          <Card>
            <CardBody>
              <Link className="glass" to="/ReportFull">
                <button className="btn btn-danger btn-sm pull-right">
                  <i className="fa fa-dot-circle-o"></i> {">>"}
                </button>
              </Link>
              <Link className="glass" to="/TabView">
                <button
                  style={{ marginRight: 10 }}
                  className="btn btn-danger btn-sm pull-right"
                >
                  {"<<"} <i className="fa fa-dot-circle-o"></i>
                </button>
              </Link>
            </CardBody>
          </Card>
          </>
        )}
        </div> */}

      </div>
        <ScrollToTop />
      </div>
    );
  }
}

export default ReportMiniEUCanada;